import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordionSummary from "@mui/material/AccordionSummary";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { neutral } from "app/themes/colors";

interface SettingsAccordionSummaryProps {
  readonly title: string;
  readonly expanded?: boolean;
  readonly onSelectAll?: (event: React.MouseEvent) => void;
  readonly onDeselectAll?: (event: React.MouseEvent) => void;
  readonly selectedCount?: number;
}

export default function SettingsAccordionSummary({
  title,
  expanded,
  onSelectAll,
  onDeselectAll,
  selectedCount = 0
}: SettingsAccordionSummaryProps) {
  return (
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      sx={{
        px: 2,
        py: 2,
        "& .Mui-expanded": {
          margin: 0
        },
        ":hover": {
          background: neutral[100]
        }
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
      >
        <Typography variant="body3" color={neutral[900]} sx={{ fontSize: 20 }}>
          {title}
        </Typography>

        <Stack direction="row" alignItems="center">
          <Typography variant="body1" color={neutral[700]}>
            Selected ({selectedCount})
          </Typography>

          {expanded && (
            <>
              {onDeselectAll && (
                <Button
                  size="small"
                  sx={{ opacity: 0.7, "&:hover": { opacity: 1 } }}
                  onClick={onDeselectAll}
                >
                  Deselect All
                </Button>
              )}
              {onSelectAll && (
                <Button
                  size="small"
                  sx={{ opacity: 0.7, "&:hover": { opacity: 1 } }}
                  onClick={onSelectAll}
                >
                  Select All
                </Button>
              )}
            </>
          )}
        </Stack>
      </Stack>
    </AccordionSummary>
  );
}
